module.exports = __webpack_public_path__ + "static/media/04.bb812b2a.png";